import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MonitoramentoComponent } from './monitoramento.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: MonitoramentoComponent}
  ])],
  exports: [RouterModule]
})
export class MonitoramentoRoutingModule { }
